import { Link } from "react-router-dom";
import BookDemoButton from "./BookDemoButton";

// Top navigation. Per product decision (2026-04-19):
//   - Only one text link: Pricing.
//   - Primary CTA (Book a demo) lives in the nav on every page.
//   - No phone number anywhere — avoids spam during pre-launch.
export default function Nav() {
  return (
    <nav className="v3-nav">
      <div className="v3-nav-inner">
        <Link to="/" className="v3-brand" aria-label="Dash home">
          Dash<em>—</em>
        </Link>
        <div className="v3-nav-right">
          <Link to="/pricing">Pricing</Link>
          <BookDemoButton />
        </div>
      </div>
    </nav>
  );
}
